import { useRef, useCallback, useEffect, memo } from 'react';
import { EffectCoverflow, Controller } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './style.module.scss';

export const list = [
  '隐灵台',
  '九华天街',
  '三梦坊',
  '御隐师协会',
  '掠影阁',
  '殊林',
  '魔域',
];

const About = () => {
  const gallerySwiperRef = useRef(null);
  const thumbSwiperRef = useRef(null);

  const onClickChangeSlide = (direction) => {
    const { current: swiper } = gallerySwiperRef;
    if (direction === 'prev') {
      swiper.slidePrev();
    } else {
      swiper.slideNext();
    }
  };

  const onGallerySwiper = useCallback((swiper) => {
    gallerySwiperRef.current = swiper;
  }, []);

  const onThumbSwiper = useCallback((swiper) => {
    thumbSwiperRef.current = swiper;
  }, []);

  useEffect(() => {
    thumbSwiperRef.current.controller.control = gallerySwiperRef.current;
    gallerySwiperRef.current.controller.control = thumbSwiperRef.current;
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.contentWrap}>
        <div className={styles.prev} onClick={() => { onClickChangeSlide('prev'); }} />
        <div className={styles.next} onClick={() => { onClickChangeSlide('next'); }} />
        <Swiper
          className={styles.gallerySwiper}
          modules={[EffectCoverflow, Controller]}
          slidesPerView={1}
          loopedSlides={5}
          onSwiper={onGallerySwiper}
          effect="coverflow"
          grabCursor
          centeredSlides
          coverflowEffect={{
            rotate: 30,
            stretch: 10,
            depth: 60,
            modifier: 2,
            slideShadows: false,
          }}
          loop
        >
          {new Array(7).fill('').map((_, index) => (
            <SwiperSlide key={index}>
              <div className={styles.galleryItem}>
                <div className={styles.galleryFigureWrap}>
                  <figure className={styles[`item${index}`]} />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className={styles.thumbList}>
          <div className={styles.dash} />
          <Swiper
            centeredSlides
            modules={[Controller]}
            slidesPerView={5}
            touchRatio={0.2}
            slideToClickedSlide
            loop
            loopedSlides={5}
            onSwiper={onThumbSwiper}
            allowTouchMove={false}
            className={styles.thumbSwiper}
          >
            {list.map((item) => (
              <SwiperSlide key={item}>
                <div className={styles.thumbItem}>
                  <span className={styles.iconRect} />
                  <p>{ item }</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default memo(About);
